// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LayoutLogin_sectionLogin__T2YsF {
    background: var(--color-neutral-100);
    width: 100%;
    max-width: 1125px;
    overflow: hidden;
    border: 1px solid var(--color-black);
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
}

.LayoutLogin_layoutLogo__-ybFY {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;
    padding: 40px 0;
    border-bottom: 1px solid var(--color-black);
    background: #F3F5FD;
    width: 100%;
}

.LayoutLogin_layoutLogo__-ybFY>img {
    width: 40%;
}

.LayoutLogin_layoutForm__0\\+8U7 {
    padding: 40px 16px;
}

.LayoutLogin_layoutForm__0\\+8U7>div {
    width: 100%;
}

@media screen and (min-width: 992px) {

    .LayoutLogin_sectionLogin__T2YsF {
        display: flex;
    }

    .LayoutLogin_layoutLogo__-ybFY {
        width: 35%;
        gap: 80px;
        border-bottom: none;
        border-left: 1px solid var(--color-black);
    }

    .LayoutLogin_layoutLogo__-ybFY>img {
        width: 60%;
        height: auto;
    }

    .LayoutLogin_layoutForm__0\\+8U7 {
        width: 75%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Styles/Authentication/LayoutLogin.module.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,oCAAoC;IACpC,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,2CAA2C;IAC3C,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,SAAS;QACT,mBAAmB;QACnB,yCAAyC;IAC7C;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".sectionLogin {\n    background: var(--color-neutral-100);\n    width: 100%;\n    max-width: 1125px;\n    overflow: hidden;\n    border: 1px solid var(--color-black);\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n}\n\n.layoutLogo {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 40px;\n    padding: 40px 0;\n    border-bottom: 1px solid var(--color-black);\n    background: #F3F5FD;\n    width: 100%;\n}\n\n.layoutLogo>img {\n    width: 40%;\n}\n\n.layoutForm {\n    padding: 40px 16px;\n}\n\n.layoutForm>div {\n    width: 100%;\n}\n\n@media screen and (min-width: 992px) {\n\n    .sectionLogin {\n        display: flex;\n    }\n\n    .layoutLogo {\n        width: 35%;\n        gap: 80px;\n        border-bottom: none;\n        border-left: 1px solid var(--color-black);\n    }\n\n    .layoutLogo>img {\n        width: 60%;\n        height: auto;\n    }\n\n    .layoutForm {\n        width: 75%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionLogin": `LayoutLogin_sectionLogin__T2YsF`,
	"layoutLogo": `LayoutLogin_layoutLogo__-ybFY`,
	"layoutForm": `LayoutLogin_layoutForm__0+8U7`
};
export default ___CSS_LOADER_EXPORT___;
